import store from "../store";

export default {
  install(Vue) {
    Vue.prototype.$operatorRetail = () => {
      // Retail = 0 Não tem retail
      // Retail = 1 Operação Simplificada, NÃO tem rotas, Arrecadadores, Financeiro Simplificado
      // Retail = 2 Operação completa, Tem rotas, Arrecadadores, Financeiro Completo
      return store.state.operators.retail
    }

  }
}